import React, { Component } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

export default class Carousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            responsive: {
                0: {items: 1},
                700: {items: 2},
                900: {items: 4}
            },
            maxItemsShown: 4
        };

        this.handleWindowResize = this.handleWindowResize.bind(this);
    }

    componentDidMount() {
        this.countMaxItemsShown();
        window.addEventListener('resize', this.handleWindowResize, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize, false);
    }

    handleWindowResize() {
        this.countMaxItemsShown();
    }

    countMaxItemsShown() {
        let itemsForCurrentBreakpoint = 0;
        for (const [key, value] of Object.entries(this.state.responsive)) {
            if (window.innerWidth > key) {
                itemsForCurrentBreakpoint = value.items;
            }
        };
        this.setState({maxItemsShown: itemsForCurrentBreakpoint});
    }

    render() {
        let items = [];
        for(let i = 0; i < this.props.items.length; i++) {
            items.push(
                <div className="teaser-list__carousel-item" data-value={i}
                     dangerouslySetInnerHTML={{__html: this.props.items[i].innerHTML}}></div>
            )
        }

        return (
            <React.Fragment>
                {items.length > this.state.maxItemsShown &&
                    <button type="button" title="Show previous slide"
                        className="teaser-list__carousel-button teaser-list__carousel-button--prev"
                        onClick={() => this.Carousel.slidePrev()}/>
                }
                <AliceCarousel
                    disableDotsControls={this.props.dotsDisabled || false}
                    disableButtonsControls={true}
                    items={this.props.itemsPure ? this.props.itemsPure : items}
                    responsive={this.state.responsive}
                    ref={(el) => (this.Carousel = el)}
                />
                {items.length > this.state.maxItemsShown &&
                    <button type="button" title="Show next slide"
                        className="teaser-list__carousel-button teaser-list__carousel-button--next"
                        onClick={() => this.Carousel.slideNext()}/>
                }
            </React.Fragment>
        );
    }
}
